import type { FC } from "react";
import { Flex, Text } from "@huub-web/ui";
import { useTranslation } from "react-i18next";

import type { AuthLegalLink } from "../../../types";

type LegalLinksProps = {
  /**
   * Legal links to display (e.g. privacy statement, terms)
   */
  links: AuthLegalLink[];
};

/**
 * Renders a row of tenant-specific legal links on auth pages.
 */
export const LegalLinks: FC<LegalLinksProps> = ({ links }) => {
  const { t } = useTranslation();

  if (links.length === 0) return null;

  return (
    <Flex direction="row" gap="s" justify="center" wrap>
      {links.map((link) => (
        <Text key={link.labelKey} variant="bodyS" color="currentColor50">
          <a href={link.url} target="_blank" rel="noopener noreferrer">
            {t(link.labelKey)}
          </a>
        </Text>
      ))}
    </Flex>
  );
};
